import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ClientAuthProvider } from "@/context/ClientAuthContext";
import { BookingProvider } from "@/context/BookingContext";
import AuthModal from "@/components/AuthModal";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Manage from "@/pages/Manage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AccountPage from "@/pages/AccountPage";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import BookingPolicy from "@/pages/BookingPolicy";

function AppRoutes() {
  const location = useLocation();
  // Handle Google OAuth return (session_id lands in the URL fragment) before any route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <AuthModal />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/book" element={<Landing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/manage/:token" element={<Manage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/policy" element={<BookingPolicy />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ClientAuthProvider>
            <BookingProvider>
              <AppRoutes />
            </BookingProvider>
          </ClientAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
